import React from 'react';
import { MapPin, Bed, TreePine } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { DistanceFilter } from './DistanceFilter';
import { hebergementsChevaux } from './venirData';

export default function HebergementsTab({ filteredHebergements, hebergementFilter, setHebergementFilter }) {
  return (
    <div data-testid="hebergements-tab">
      <div className="mb-6">
        <h2 className="font-['Playfair_Display'] text-2xl font-bold text-zinc-900 mb-2">Où dormir ?</h2>
        <p className="text-zinc-600 mb-4">Hébergements recommandés autour du Domaine de la Briouse</p>
        <DistanceFilter value={hebergementFilter} onChange={setHebergementFilter} testId="hebergement-filter" />
      </div>

      <div className="mb-8">
        <h3 className="text-lg font-semibold text-zinc-800 mb-4 flex items-center gap-2">
          <Bed className="h-5 w-5 text-fuchsia-500" /> Pour les personnes
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {filteredHebergements.map((h, index) => (
            <Card key={index} className={`border-0 shadow-lg hover:-translate-y-1 transition-all ${h.highlight ? 'ring-2 ring-fuchsia-500' : ''}`} data-testid={`hebergement-${index}`}>
              <CardContent className="p-6">
                {h.highlight && <span className="inline-block px-3 py-1 bg-fuchsia-100 text-fuchsia-600 rounded-full text-xs font-medium mb-3">Sur place</span>}
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h3 className="font-bold text-zinc-900">{h.name}</h3>
                    <p className="text-sm text-fuchsia-600">{h.type}</p>
                  </div>
                  <Badge variant="outline" className="text-xs">{h.distanceLabel}</Badge>
                </div>
                <p className="text-sm text-zinc-600 mb-2">{h.description}</p>
                {h.address && <p className="text-xs text-zinc-500 mb-1 flex items-center gap-1"><MapPin className="h-3 w-3" /> {h.address}</p>}
                {h.phone && <a href={`tel:${h.phone.replace(/\s/g, '')}`} className="text-xs text-zinc-500 hover:text-fuchsia-600 mb-1 flex items-center gap-1">Tel: {h.phone}</a>}
                <div className="flex justify-between items-center mt-3">
                  <span className="font-semibold text-lime-600">{h.price}</span>
                  {h.url && <a href={h.url} target="_blank" rel="noopener noreferrer"><Button variant="outline" size="sm" className="rounded-full">Réserver</Button></a>}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-zinc-800 mb-4 flex items-center gap-2">
          <TreePine className="h-5 w-5 text-lime-500" /> Pour les chevaux
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {hebergementsChevaux.map((h, index) => (
            <Card key={index} className={`border-0 shadow-lg hover:-translate-y-1 transition-all ${h.highlight ? 'ring-2 ring-lime-500 bg-lime-50' : ''}`} data-testid={`hebergement-cheval-${index}`}>
              <CardContent className="p-6">
                {h.highlight && <span className="inline-block px-3 py-1 bg-lime-100 text-lime-600 rounded-full text-xs font-medium mb-3">Sur place</span>}
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h3 className="font-bold text-zinc-900">{h.name}</h3>
                    <p className="text-sm text-lime-600">{h.type}</p>
                  </div>
                  <Badge variant="outline" className="text-xs">{h.distanceLabel}</Badge>
                </div>
                <p className="text-sm text-zinc-600 mb-2">{h.description}</p>
                {h.address && <p className="text-xs text-zinc-500 mb-1 flex items-center gap-1"><MapPin className="h-3 w-3" /> {h.address}</p>}
                {h.phone && <a href={`tel:${h.phone.replace(/\s/g, '')}`} className="text-xs text-zinc-500 hover:text-lime-600 mb-1 flex items-center gap-1">Tel: {h.phone}</a>}
                <div className="flex justify-between items-center mt-3">
                  <span className="font-semibold text-fuchsia-600">{h.price}</span>
                  {h.url && <a href={h.url} target="_blank" rel="noopener noreferrer"><Button variant="outline" size="sm" className="rounded-full">Voir le site</Button></a>}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      <div className="mt-8 flex gap-4 justify-center">
        <a href="https://www.booking.com/searchresults.fr.html?ss=Sanxay" target="_blank" rel="noopener noreferrer">
          <Button variant="outline" className="rounded-full">Voir sur Booking</Button>
        </a>
        <a href="https://www.airbnb.fr/s/Sanxay--France" target="_blank" rel="noopener noreferrer">
          <Button variant="outline" className="rounded-full">Voir sur Airbnb</Button>
        </a>
      </div>
    </div>
  );
}
